import React, { Component } from "react";

import styles from "../../../components/Client/styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col } from "react-bootstrap";
import $ from "jquery";
import PROMO_A from "../../../assets/images/error-404.svg";
import {
  agreementVerificationSuppliers,
  saveVerificationAgreementSuppliers,
  saveChooseSignatureSigneeSupplier,
} from "../../../config/api_calls";
import { REPLACECONTENTCLIENT } from "../../../config/utility";
import {
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
  ADMIN_URL,
} from "../../../config/config";
import "../../../components/Client/agreement.css";
import HelperClass from "../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import { tableLoaderAgreement } from "../../../components/ContentLoaders/table_loader_agreement";
import NotificationToast from "../../../components/Notification/NotificationToast";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const auth = new HelperClass();

export default class AgreementsVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
      tableLoaderAgreement: true,
      errorMessageSignee: "",
      successMessageSignee: "",
      agreementData: [],
      replacable_content: "",
      final_content: "",
      agreement_id: "",
      agreement_accountno: "",
      agreement_title: "",
      vendor_signature: "",
      agreement_type: "esign",
      is_checked: "",
      signatureText: "",
      signatureClass: "'Amita', cursive",
      signature_type: "draw",
      client_token: "",
      agent_accountno: "",
      reseller_identifier: "",
      uploadedSignature: "",
      signatureDrawn: false,
      signatureColor: "#000000",
      loadingButton: false,
      activeTabIndex: 0,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      scrollProgress: 0,
      consentChecked: false,
      currentStep: 1,
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      signatureDataUrl: "",
      downloading: false,
      downloadingFormat: "",
      resellerData: [],
      userData: [],
    };
    this.signatureColors = [
      { name: "Light Gray", value: "#c0c0c0", size: 10 },
      { name: "Gray", value: "#808080", size: 14 },
      { name: "Dark Gray", value: "#404040", size: 18 },
      { name: "Blue", value: "#1a73e8", size: 22 },
      { name: "Black", value: "#000000", size: 24 },
      { name: "Green", value: "#0d7c3f", size: 24 },
      { name: "Brown", value: "#8B4513", size: 24 },
    ];
    this.cursiveFonts = [
      { name: "Your Signature", value: "'Amita', cursive" },
      { name: "Your Signature", value: "'Bad Script', cursive" },
      { name: "Your Signature", value: "'Damion', cursive" },
      { name: "Your Signature", value: "'Dancing Script', cursive" },
      { name: "Your Signature", value: "'Felipa', cursive" },
      { name: "Your Signature", value: "'Julee', cursive" },
      { name: "Your Signature", value: "'Kaushan Script', cursive" },
      { name: "Your Signature", value: "'Lugrasimo', cursive" },
      { name: "Your Signature", value: "'Pacifico', cursive" },
      { name: "Your Signature", value: "'Sofia', cursive" },
      { name: "Your Signature", value: "'Yellowtail', cursive" },
    ];
  }

  async componentDidMount() {
    let apiHit = await agreementVerificationSuppliers(
      this.props.match.params.verification_token
    );
    if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "Invalid Credientials"
    ) {
      this.setState({
        errorMessage: "Invalid Credentials.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "no_record"
    ) {
      this.setState({
        errorMessage:
          "Oops! Your temporary URL has been expired or does not exists.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "already_signed"
    ) {
      this.setState({
        errorMessage: "Oops! Agreement already signed.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    } else if (apiHit.data.status === 200) {
      let client_signor_name = apiHit.data.data[0][10];
      if (client_signor_name === "") {
        client_signor_name = apiHit.data.user_data[0]["name"];
      }
      let objReplace = {
        resellerCompName: apiHit.data.reseller_data[0].comp_name,
        client_name: client_signor_name,
        client_comp_name: apiHit.data.user_data[0]["comp_name"],
        client_email: apiHit.data.user_data[0]["email"],
        client_address: apiHit.data.user_data[0]["address"]
          ? apiHit.data.user_data[0]["address"]
          : "N/A",
        client_city: apiHit.data.user_data[0]["city"]
          ? apiHit.data.user_data[0]["city"]
          : "N/A",
        client_state: apiHit.data.user_data[0]["state"]
          ? apiHit.data.user_data[0]["state"]
          : "N/A",
        client_zip: apiHit.data.user_data[0]["zip"]
          ? apiHit.data.user_data[0]["zip"]
          : "N/A",
        client_country: apiHit.data.user_data[0]["country"]
          ? apiHit.data.user_data[0]["country"]
          : "N/A",
        client_phone_no: apiHit.data.user_data[0]["phone"],
        vendor_signor_name: apiHit.data.reseller_data[0].name,
        vendor_signor_comp_name: apiHit.data.reseller_data[0].comp_name,
        vendor_signor_title: apiHit.data.reseller_data[0].title,
        vendor_signor_address: apiHit.data.reseller_data[0].address,
        vendor_signor_email: "N/A",
        vendor_signor_phone_no: apiHit.data.reseller_data[0].phone,
        vendor_signor_fax: "N/A",
        vendor_signor_city: apiHit.data.reseller_data[0].city,
        vendor_signor_state: apiHit.data.reseller_data[0].state,
        vendor_signor_zip: apiHit.data.reseller_data[0].zip,
        vendor_signor_comp_title: apiHit.data.reseller_data[0].comp_name,

        company_profile_name: apiHit.data.company_profile.name || "N/A",
        company_profile_title: apiHit.data.company_profile.title || "N/A",
        company_profile_address: apiHit.data.company_profile.address
          ? `${apiHit.data.company_profile.address}`
          : "N/A",
        company_profile_full_address: apiHit.data.company_profile.address
          ? `${apiHit.data.company_profile.address}, ${apiHit.data.company_profile.city}, ${apiHit.data.company_profile.state}, ${apiHit.data.company_profile.zip}, ${apiHit.data.company_profile.country}`
          : "N/A",
        company_profile_city: apiHit.data.company_profile.city || "N/A",
        company_profile_phone: apiHit.data.company_profile.phone || "N/A",
        company_profile_email: apiHit.data.company_profile.email || "N/A",
        company_profile_state: apiHit.data.company_profile.state || "N/A",
        company_profile_country: apiHit.data.company_profile.country || "N/A",
        company_profile_zip: apiHit.data.company_profile.zip || "N/A",
        company_profile_sign: apiHit.data.company_profile.sign || "N/A",
        company_profile_company_name:
          apiHit.data.company_profile.comp_name || "N/A",
      };
      let final_content = apiHit.data.data[0][1];
      let signature =
        apiHit.data.reseller_data[0].signature_image &&
        apiHit.data.reseller_data[0].signature_image !== ""
          ? ADMIN_URL +
            "files_data/logos/" +
            apiHit.data.reseller_data[0].signature_image
          : VENDOR_SIGNATURE;
      final_content = REPLACECONTENTCLIENT(
        final_content,
        objReplace,
        ""
      ).replace(/\[\[IMG_VENDOR_SIGN\]\]/g, signature);
      this.setState({
        replacable_content: objReplace,
        agreementData: apiHit.data.data,
        errorMessage: "",
        final_content: final_content,
        bgColor: "white",
        defaultLoader: false,
        agreement_id: apiHit.data.data[0][0],
        agreement_type: apiHit.data.data[0][8],
        agreement_title: apiHit.data.data[0][9],
        agreement_accountno: apiHit.data.data[0][6],
        vendor_signature: signature,
        tableLoaderAgreement: false,
        client_token: apiHit.data.token,
        agent_accountno: apiHit.data.user_data[0]["accountno"],
        reseller_identifier: apiHit.data.reseller_data[0].reseller_identifier,
        resellerData: apiHit.data.reseller_data || [],
        userData: apiHit.data.user_data || [],
      }, () => {
        setTimeout(() => this.checkContentScrollable(), 500);
      });
    } else {
      this.setState({
        errorMessage:
          "Oops! There is some error while processing your request.",
        successMessage: "",
        tableLoaderAgreement: false,
      });
    }
  }

  clear = () => {
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.setState({ signatureDrawn: false, modalCanvasEmpty: true, signatureDataUrl: "" });
    $("#divSig").hide();
    $(".clsimgSig").attr("src", "");
    $(".clsimgSig").hide();
  };

  resetCanvas = () => {
    if (this.signaturePad) {
      this.signaturePad.clear();
      window.dispatchEvent(new Event("resize"));
    }
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
  };

  isSaveDisabled = () => {
    if (this.state.loadingButton) return true;
    if (this.state.agreement_type === "accept" && this.state.is_checked !== "yes") return true;
    if (this.state.agreement_type === "esign") {
      if (this.state.signature_type === "draw" && !this.state.signatureDrawn) return true;
      if (this.state.signature_type === "choose" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "type" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "upload" && this.state.uploadedSignature === "") return true;
    }
    return false;
  };

  save = async () => {
    if (this.state.agreement_type === "accept" && this.state.is_checked !== "yes") {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage: "For account activation and further processing. You must accept the agreement.",
      });
    }
    if (this.state.agreement_type === "esign" && this.state.signature_type === "draw" && this.signaturePad && this.signaturePad.isEmpty() && !this.state.signatureDataUrl) {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage: "For account activation and further processing. You must sign the mandatory agreements.",
      });
    }
    if (this.state.agreement_type === "esign" && (this.state.signature_type === "choose" || this.state.signature_type === "type") && this.state.signatureText === "") {
      window.$("#modalAlertError").modal("show");
      return this.setState({
        errorMessage: "Please enter the authorized person name.",
      });
    }

    if (this.state.agreement_type === "accept" || this.state.signature_type === "draw") {
      this.setState({ loadingButton: true, errorMessage: "" });
      var data = "";
      if (this.state.agreement_type === "esign") {
        data = this.signaturePad.getTrimmedCanvas().toDataURL("image/svg+xml");
      }
      let content_div_id = "agreement_content_" + this.state.agreement_id;
      var final_content = document.getElementById(content_div_id).innerHTML;
      const apiHit = await saveVerificationAgreementSuppliers(
        this.state.agent_accountno,
        this.state.client_token,
        data,
        final_content.replace("CLIENT SIGNATURE DATE SHOWN HERE", this.props.published_date),
        this.state.agreement_id,
        this.state.agreement_accountno,
        this.state.vendor_signature,
        this.state.agreement_type
      );
      if (apiHit.data.status === 404) {
        window.$("#modalAlertError").modal("show");
        this.setState({
          errorMessage: "We are sorry, something went wrong try later.",
          loadingButton: false,
        });
      } else if (apiHit.data.status === 200 && apiHit.data.data === "success") {
        this.handleAgreementSaveSuccess(
          this.state.agreement_type === "accept"
            ? "The agreement has been accepted successfully."
            : "The agreement has been successfully signed."
        );
      }
    } else if (this.state.signature_type === "choose" || this.state.signature_type === "type" || this.state.signature_type === "upload") {
      this.submitSignatoryDetails();
    }
  };

  submitSignatoryDetails = async () => {
    let { signatureText, signature_type } = this.state;
    this.setState({ loadingButton: true });
    if ((signature_type === "choose" || signature_type === "type") && signatureText === "") {
      window.$("#modalAlertError").modal("show");
      this.setState({ errorMessage: "Please enter the authorized person name.", loadingButton: false });
      return;
    }
    if (signature_type === "upload" && this.state.uploadedSignature === "") {
      window.$("#modalAlertError").modal("show");
      this.setState({ errorMessage: "Please upload a signature image.", loadingButton: false });
      return;
    }
    if (signature_type === "choose" || signature_type === "type") {
      await this.saveAsImage();
    }
    if (signature_type === "upload") {
      await this.saveUploadedSignature();
    }
  };

  saveAsImage = async () => {
    let { signatureText, signature_type } = this.state;
    const element = document.getElementById("styled-text-container") || document.getElementById("typed-text-container");
    if (element) {
      html2canvas(element, { scale: 2, backgroundColor: null }).then(
        async (canvas) => {
          const imgData = canvas.toDataURL("image/png");
          let content_div_id = "agreement_content_" + this.state.agreement_id;
          var final_content = document.getElementById(content_div_id).innerHTML;
          const apiData = await saveChooseSignatureSigneeSupplier(
            this.state.agent_accountno,
            this.state.client_token,
            imgData,
            signatureText,
            signature_type,
            final_content.replace("VENDOR SIGNATURE DATE SHOWN HERE", this.props.published_date),
            this.state.agreement_id,
            VENDOR_SIGNATURE,
            this.state.agreement_type
          );
          if (apiData.data.status === 404) {
            this.setState({
              errorMessage: "There is some error while processing your request.",
              loadingButton: false,
            });
          } else if (apiData.data.status === 200 && apiData.data.data === "success") {
            this.handleAgreementSaveSuccess("Agreement has been signed successfully.");
          }
        }
      );
    }
  };

  saveUploadedSignature = async () => {
    let { uploadedSignature, signature_type } = this.state;
    if (uploadedSignature) {
      let content_div_id = "agreement_content_" + this.state.agreement_id;
      var final_content = document.getElementById(content_div_id).innerHTML;
      const apiData = await saveChooseSignatureSigneeSupplier(
        this.state.agent_accountno,
        this.state.client_token,
        uploadedSignature,
        "uploaded_signature",
        signature_type,
        final_content.replace("VENDOR SIGNATURE DATE SHOWN HERE", this.props.published_date),
        this.state.agreement_id,
        VENDOR_SIGNATURE,
        this.state.agreement_type
      );
      if (apiData.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while processing your request.",
          loadingButton: false,
        });
      } else if (apiData.data.status === 200 && apiData.data.data === "success") {
        this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
      }
    }
  };

  handleAgreementSaveSuccess = (message) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState({
      successMessage: "",
      errorMessage: "",
      toastMessage: message,
      toastType: "success",
      toastTitle: this.state.agreement_type === "accept" ? "Agreement Accepted" : "Agreement Signed",
      loadingButton: false,
      is_checked: "",
      signatureDrawn: false,
      signatureText: "",
      uploadedSignature: "",
      signature_type: "draw",
      signatureColor: "#000000",
      currentStep: 1,
      scrollProgress: 0,
      consentChecked: false,
    });
    if (this.signaturePad) this.signaturePad.clear();

    const isLastAgreement = this.state.agreementData.length <= 1;
    const targetIndex = Math.max(0, this.state.activeTabIndex - 1);
    setTimeout(async () => {
      this.setState({ successMessage: "" });
      await this.componentDidMount();
      if (!isLastAgreement) {
        const newData = this.state.agreementData;
        if (newData && newData.length > 0) {
          const idx = Math.min(targetIndex, newData.length - 1);
          this.show_agreement_content(newData[idx][0], newData[idx][1], newData[idx][8], newData[idx][2]);
        }
      }
    }, 3000);
  };

  handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        window.$("#modalAlertError").modal("show");
        this.setState({ errorMessage: "File size must be less than 2MB." });
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.setState({ uploadedSignature: event.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  set_data = (agreement_content) => {
    this.setState({ final_content: agreement_content });
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.value : target.value;
    const { name } = target;
    this.setState({ [name]: value });
  };

  updateSignatureType = (type) => {
    if (type === "choose") {
      this.clear();
      this.setState({ signature_type: type });
    } else if (type === "type") {
      this.clear();
      this.setState({ signatureText: "", signature_type: type });
    } else if (type === "upload") {
      this.clear();
      this.setState({ signature_type: type });
    } else {
      this.clear();
      this.setState({ signatureText: "", signature_type: type }, () => {
        setTimeout(() => this.resetCanvas(), 100);
      });
    }
  };

  handleSignature = (family) => {
    this.setState({ signatureClass: family });
  };

  preview = () => {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      var data = this.signaturePad.getTrimmedCanvas().toDataURL("image/svg+xml");
      $("#divSig").show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
    }
  };

  class_manage_link = (ids) => {
    return ids === this.state.activeTabIndex ? "nav-link active" : "nav-link";
  };

  class_manage_content = (ids) => {
    return ids === this.state.activeTabIndex ? "tab-pane active" : "tab-pane";
  };

  class_required = (ids) => {
    if (ids === 1) {
      return (
        <sup style={{ fontSize: "100%" }}>
          <small style={{ color: "#e85347", fontSize: "100%" }}>*</small>
        </sup>
      );
    }
    return "";
  };

  set_tabs = (ids) => (ids !== "" ? "#agreement" + ids : "tab-pane");
  set_tabs_content = (ids) => (ids !== "" ? "agreement" + ids : "tab-pane");

  show_agreement_content = async (ids, agreement_content, agreement_type, agreement_title) => {
    let final_content = agreement_content;
    if (final_content !== "") {
      final_content = REPLACECONTENTCLIENT(agreement_content, this.state.replacable_content, "").replace(
        /\[\[IMG_VENDOR_SIGN\]\]/g,
        this.state.vendor_signature
      );
    }
    const tabIndex = this.state.agreementData.findIndex((a) => a[0] === ids);
    this.setState(
      {
        final_content: final_content,
        agreement_id: ids,
        agreement_type: agreement_type,
        agreement_title: agreement_title,
        activeTabIndex: tabIndex >= 0 ? tabIndex : 0,
        signatureDrawn: false,
        is_checked: "",
        signatureText: "",
        uploadedSignature: "",
        signature_type: "draw",
        loadingButton: false,
        scrollProgress: 0,
        consentChecked: false,
        currentStep: 1,
      },
      () => {
        if (this.signaturePad) this.signaturePad.clear();
        setTimeout(() => this.checkContentScrollable(), 300);
      }
    );
  };

  close_window = () => {
    const closeResult = window.close();
    if (closeResult === false || window.location.href.indexOf("about:blank") === -1) {
      window.location.href = document.referrer || "/";
    }
  };

  handlePrint = () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) return;
    const activeTabId = activeTabPane.id;
    const printableElement = document.getElementById(activeTabId);
    if (printableElement) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(printableElement.innerHTML);
      printWindow.print();
      printWindow.close();
    }
  };

  openSignatureModal = () => {
    const hasInlineSignature = this.signaturePad && !this.signaturePad.isEmpty();
    this.setState({ signatureModalOpen: true, modalCanvasEmpty: !hasInlineSignature }, () => {
      setTimeout(() => {
        if (this.signaturePad && this.signaturePadModal && !this.signaturePad.isEmpty()) {
          const dataUrl = this.signaturePad.toDataURL();
          this.signaturePadModal.fromDataURL(dataUrl);
        }
      }, 100);
    });
  };

  handleDocumentScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - clientHeight > 0) {
      const progress = Math.round((scrollTop / (scrollHeight - clientHeight)) * 100);
      const clamped = Math.min(progress, 100);
      if (clamped > this.state.scrollProgress) {
        this.setState({ scrollProgress: clamped });
      }
    }
  };

  checkContentScrollable = () => {
    const el = this.scrollContainerRef;
    if (el) {
      if (el.scrollHeight <= el.clientHeight + 5) {
        this.setState({ scrollProgress: 100 });
      }
    }
  };

  goToStep = (step) => {
    if (step === 2) {
      if (this.state.scrollProgress < 100) {
        window.$("#modalAlertError").modal("show");
        this.setState({ errorMessage: "Please read the entire agreement before proceeding." });
        return;
      }
      if (!this.state.consentChecked) {
        window.$("#modalAlertError").modal("show");
        this.setState({ errorMessage: "Please confirm your identity and consent before proceeding." });
        return;
      }
    }
    this.setState({ currentStep: step });
  };

  downloadPdf = () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) return;
    const activeTab = document.querySelector(".nav-link.active span");
    const documentTitle = activeTab ? activeTab.textContent.trim() : "Agreement";
    this.setState({ downloading: true, downloadingFormat: "PDF" });

    const clone = activeTabPane.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.style.cssText = "position:fixed;left:-9999px;top:0;width:794px;padding:40px 50px;background:#fff;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.6;color:#000;";
    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);

    html2canvas(wrapper, { scale: 2, useCORS: true, backgroundColor: "#ffffff", width: 794, windowWidth: 794 })
      .then((canvas) => {
        document.body.removeChild(wrapper);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 10;
        const contentWidth = pdfWidth - margin * 2;
        const contentHeight = pdfHeight - margin * 2;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;
        let heightLeft = imgHeight;
        let page = 0;

        while (heightLeft > 0) {
          if (page > 0) pdf.addPage();
          const sourceY = page * contentHeight * (canvas.width / contentWidth);
          const sourceHeight = Math.min(contentHeight * (canvas.width / contentWidth), canvas.height - sourceY);
          if (sourceHeight <= 0) break;
          const pageCanvas = document.createElement("canvas");
          pageCanvas.width = canvas.width;
          pageCanvas.height = sourceHeight;
          const ctx = pageCanvas.getContext("2d");
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
          ctx.drawImage(canvas, 0, sourceY, canvas.width, sourceHeight, 0, 0, canvas.width, sourceHeight);
          const sliceImgData = pageCanvas.toDataURL("image/png");
          const sliceHeight = (sourceHeight * contentWidth) / canvas.width;
          pdf.addImage(sliceImgData, "PNG", margin, margin, contentWidth, sliceHeight);
          heightLeft -= contentHeight;
          page++;
        }
        pdf.save(documentTitle + ".pdf");
        this.setState({ downloading: false, downloadingFormat: "" });
      })
      .catch(() => {
        document.body.removeChild(wrapper);
        this.setState({ downloading: false, downloadingFormat: "" });
      });
  };

  downloadTxt = () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) return;
    const activeTab = document.querySelector(".nav-link.active span");
    const documentTitle = activeTab ? activeTab.textContent.trim() : "Document";
    this.setState({ downloading: true, downloadingFormat: "TXT" });
    const content = activeTabPane.innerHTML || "";
    const cleanedHtml = content
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
      .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<[^>]+>/g, "");
    const decoder = document.createElement("textarea");
    decoder.innerHTML = cleanedHtml;
    const text = decoder.value
      .replace(/\u00A0/g, " ")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .replace(/\r\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
    const blob = new Blob([text], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = documentTitle + ".txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.setState({ downloading: false, downloadingFormat: "" });
  };
  renderStepPanel = () => {
    const { currentStep, scrollProgress, agreement_type } = this.state;
    return (
      <div className="card card-bordered" style={{ backgroundColor: this.props.backgroundColor, border: "none", position: "sticky", top: "80px" }}>
        <div className="card-inner">
          {currentStep === 1 ? (
            <div>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", gap: "8px" }}>
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "50%", backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, fontSize: "13px", fontWeight: "700", flexShrink: 0 }}>1</span>
                <div>
                  <div style={{ fontWeight: "600", fontSize: "14px", color: "#364a63" }}>Review &amp; Verify</div>
                  <div style={{ fontSize: "12px", color: "#8094ae" }}>Step 1 of 2</div>
                </div>
              </div>

              <h6 className="title mb-3"><em className="icon ni ni-users" style={{ marginRight: "6px" }}></em>Parties</h6>

              {this.state.resellerData.length > 0 && (
                <div className="card card-bordered mb-3" style={{ border: "1px solid #e5e9f2" }}>
                  <div className="card-inner py-2 px-3">
                    <h6 style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", margin: "0 0 6px 0" }}>Disclosing Party</h6>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: "#364a63" }}>{this.state.resellerData[0].comp_name}</div>
                    <div style={{ fontSize: "12px", color: "#8094ae", marginTop: "2px" }}>
                      {this.state.resellerData[0].address ? `${this.state.resellerData[0].address}, ${this.state.resellerData[0].city}, ${this.state.resellerData[0].state} ${this.state.resellerData[0].zip}` : ""}
                    </div>
                  </div>
                </div>
              )}

              {this.state.userData.length > 0 && (
                <div className="card card-bordered mb-3" style={{ border: "1px solid #e5e9f2" }}>
                  <div className="card-inner py-2 px-3">
                    <h6 style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", margin: "0 0 6px 0" }}>Receiving Party &mdash; Signing Now</h6>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: "#364a63" }}>{this.state.userData[0]["name"]}</div>
                    <div style={{ fontSize: "12px", color: "#8094ae", marginTop: "2px" }}>{this.state.userData[0]["comp_name"]}</div>
                    <div style={{ fontSize: "12px", color: "#8094ae", marginTop: "2px" }}>{this.state.userData[0]["email"]}</div>
                  </div>
                </div>
              )}

              <div className="alert alert-light alert-icon mb-3" style={{ fontSize: "12px" }}>
                <em className="icon ni ni-shield-check"></em>{" "}
                <strong>Secure Document</strong> � This agreement is encrypted and legally binding once signed.
              </div>

              <div
                style={{ border: this.state.consentChecked ? "1px solid #1ee0ac" : "1px solid #e5e9f2", borderRadius: "6px", padding: "14px 14px 14px 16px", marginBottom: "16px", backgroundColor: this.state.consentChecked ? "#edfff8" : "#fff", transition: "all 0.2s ease", display: "flex", alignItems: "flex-start", gap: "10px", cursor: "pointer" }}
                onClick={() => this.setState({ consentChecked: !this.state.consentChecked })}
              >
                <div style={{ width: "20px", height: "20px", borderRadius: "4px", border: this.state.consentChecked ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5", backgroundColor: this.state.consentChecked ? THEME_COLOR : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px", transition: "all 0.15s ease" }}>
                  {this.state.consentChecked && (<em className="icon ni ni-check" style={{ color: "#fff", fontSize: "13px", lineHeight: 1 }}></em>)}
                </div>
                <div style={{ fontSize: "12px", lineHeight: "1.6", color: "#364a63" }}>
                  I confirm I am{" "}<strong>{this.state.userData.length > 0 ? this.state.userData[0]["name"] : "the authorized signee"}</strong>, authorised to sign on behalf of my organisation, and agree to sign electronically with the same legal effect as a handwritten signature.
                </div>
              </div>

              {scrollProgress < 100 && (
                <div className="alert alert-warning alert-icon mb-3" style={{ fontSize: "12px" }}>
                  <em className="icon ni ni-alert-circle"></em>{" "}
                  Please scroll through the entire agreement to continue. <strong>{scrollProgress}% read</strong>
                </div>
              )}

              <button
                className="btn btn-block btn-lg"
                style={{ backgroundColor: scrollProgress >= 100 && this.state.consentChecked ? THEME_COLOR : "#c4cdd5", color: scrollProgress >= 100 && this.state.consentChecked ? THEME_TEXT_COLOR : "#fff", cursor: scrollProgress >= 100 && this.state.consentChecked ? "pointer" : "not-allowed", transition: "all 0.2s ease" }}
                onClick={() => this.goToStep(2)}
                disabled={scrollProgress < 100 || !this.state.consentChecked}
              >
                {agreement_type === "accept" ? "Continue to Accept" : "Continue to Sign"}{" "}
                <em className="icon ni ni-arrow-right" style={{ marginLeft: "4px" }}></em>
              </button>
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: "20px" }}>
                <button className="btn btn-sm btn-outline-light mb-3" onClick={() => this.goToStep(1)} style={{ display: "inline-flex", alignItems: "center" }}>
                  <em className="icon ni ni-arrow-left" style={{ marginRight: "4px" }}></em>Back to Review
                </button>
                <h5 style={{ fontWeight: "700", color: "#364a63", marginBottom: "4px" }}>
                  <em className="icon ni ni-pen" style={{ marginRight: "8px", color: THEME_COLOR }}></em>
                  {agreement_type === "accept" ? "Accept this agreement" : "Add your signature"}
                </h5>
                {agreement_type !== "accept" && (
                  <p style={{ fontSize: "13px", color: "#8094ae", margin: 0 }}>Choose how you'd like to sign this agreement</p>
                )}
              </div>

              {agreement_type === "esign" ? (
                <>
                  <div id="signature_div" style={{ width: "100%", float: "none" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "20px" }}>
                      <div onClick={() => this.updateSignatureType("draw")} style={{ padding: "14px 10px", borderRadius: "8px", border: this.state.signature_type === "draw" || this.state.signature_type === "" ? `2px solid ${THEME_COLOR}` : "2px solid #e5e9f2", backgroundColor: this.state.signature_type === "draw" || this.state.signature_type === "" ? `${THEME_COLOR}10` : "#fff", cursor: "pointer", textAlign: "center", transition: "all 0.2s ease" }}>
                        <em className="icon ni ni-edit-alt" style={{ fontSize: "22px", color: this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#8094ae", display: "block", marginBottom: "6px" }}></em>
                        <span style={{ fontSize: "12px", fontWeight: "600", color: this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#526484" }}>Draw</span>
                      </div>
                      <div onClick={() => this.updateSignatureType("choose")} style={{ padding: "14px 10px", borderRadius: "8px", border: this.state.signature_type === "choose" ? `2px solid ${THEME_COLOR}` : "2px solid #e5e9f2", backgroundColor: this.state.signature_type === "choose" ? `${THEME_COLOR}10` : "#fff", cursor: "pointer", textAlign: "center", transition: "all 0.2s ease" }}>
                        <em className="icon ni ni-text-rich" style={{ fontSize: "22px", color: this.state.signature_type === "choose" ? THEME_COLOR : "#8094ae", display: "block", marginBottom: "6px" }}></em>
                        <span style={{ fontSize: "12px", fontWeight: "600", color: this.state.signature_type === "choose" ? THEME_COLOR : "#526484" }}>Type Name</span>
                      </div>
                      <div onClick={() => this.updateSignatureType("type")} style={{ padding: "14px 10px", borderRadius: "8px", border: this.state.signature_type === "type" ? `2px solid ${THEME_COLOR}` : "2px solid #e5e9f2", backgroundColor: this.state.signature_type === "type" ? `${THEME_COLOR}10` : "#fff", cursor: "pointer", textAlign: "center", transition: "all 0.2s ease" }}>
                        <em className="icon ni ni-text" style={{ fontSize: "22px", color: this.state.signature_type === "type" ? THEME_COLOR : "#8094ae", display: "block", marginBottom: "6px" }}></em>
                        <span style={{ fontSize: "12px", fontWeight: "600", color: this.state.signature_type === "type" ? THEME_COLOR : "#526484" }}>Copy Link</span>
                      </div>
                      <div onClick={() => this.updateSignatureType("upload")} style={{ padding: "14px 10px", borderRadius: "8px", border: this.state.signature_type === "upload" ? `2px solid ${THEME_COLOR}` : "2px solid #e5e9f2", backgroundColor: this.state.signature_type === "upload" ? `${THEME_COLOR}10` : "#fff", cursor: "pointer", textAlign: "center", transition: "all 0.2s ease" }}>
                        <em className="icon ni ni-upload-cloud" style={{ fontSize: "22px", color: this.state.signature_type === "upload" ? THEME_COLOR : "#8094ae", display: "block", marginBottom: "6px" }}></em>
                        <span style={{ fontSize: "12px", fontWeight: "600", color: this.state.signature_type === "upload" ? THEME_COLOR : "#526484" }}>Upload Image</span>
                      </div>
                    </div>

                    <div className="tab-content">
                      {/* Choose Style Pane */}
                      <div className={this.state.signature_type === "choose" ? "tab-pane active" : "tab-pane"} id="tabItem5">
                        <div className="form-group mb-3">
                          <MutextField required id="signatureText" name="signatureText" type="text" label="Authorized Person Name" inputProps={{ maxLength: 30 }} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={this.state.signatureText} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" />
                        </div>
                        <h6 style={{ fontSize: "12px", fontWeight: "600", color: "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Type Name</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
                          {[{ name: "Dancing Script", label: "Handwritten", value: "'Dancing Script', cursive" }, { name: "Caveat", label: "Cursive", value: "'Caveat', cursive" }, { name: "Sacramento", label: "Classic", value: "'Sacramento', cursive" }].map((font, index) => (
                            <div key={index} onClick={() => this.handleSignature(font.value)} style={{ padding: "14px 16px", borderRadius: "8px", border: this.state.signatureClass === font.value ? `2px solid ${THEME_COLOR}` : "2px solid transparent", backgroundColor: this.state.signatureClass === font.value ? `${THEME_COLOR}08` : "#fff", cursor: "pointer", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span style={{ fontFamily: font.value, fontSize: "24px", color: "#364a63" }}>{this.state.signatureText || "Your Signature"}</span>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signatureClass === font.value ? THEME_COLOR : "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px" }}>{font.label}</span>
                                {this.state.signatureClass === font.value && (<em className="icon ni ni-check-circle" style={{ color: THEME_COLOR, fontSize: "18px" }}></em>)}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="signature-preview mt-3" id="styled-text-container" style={{ fontFamily: this.state.signatureClass, fontSize: "32px", width: "100%", maxWidth: "480px", height: "80px", background: "transparent", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000" }}>
                          {this.state.signatureText || "Your Signature"}
                        </div>
                      </div>

                      {/* Draw Pane */}
                      <div className={this.state.signature_type === "draw" || this.state.signature_type === "" ? "tab-pane active" : "tab-pane"} id="tabItem6">
                        <Row>
                          <Col sm={12}>
                            <div className="example-alert mb-4"><div className="alert alert-light">Please Save the signature to proceed.</div></div>
                            <div id="divSig" style={{ display: "none" }}>
                              <div className="mb-4"><img src="" className="clsimgSig" height="100" width="200" onError={(e) => (e.target.style.display = "none")} alt="" /></div>
                            </div>
                            <div><strong>Signature</strong></div>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "1%" }}>
                          <Col sm={12} style={{ position: "relative" }}>
                            <div style={{ position: "relative", border: "2px dashed #dbdfea", borderRadius: "8px", overflow: "hidden", backgroundColor: "#fafafa" }}>
                              <button type="button" style={{ position: "absolute", top: "6px", right: "6px", zIndex: 2, borderRadius: "4px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", border: "1px solid #dbdfea", cursor: "pointer", color: "#526484" }} onClick={() => this.openSignatureModal()} title="Sign in full screen">
                                <em className="icon ni ni-maximize" style={{ fontSize: "14px" }}></em>
                              </button>
                              <div style={{ height: "120px", position: "relative" }}>
                                <SignatureCanvas clearOnResize={false} penColor={this.state.signatureColor} canvasProps={{ style: { width: "100%", height: "100%" } }} velocityFilterWeight={0.7} throttle={50} ref={(ref) => { this.signaturePad = ref; }} onEnd={() => this.setState({ signatureDrawn: true })} />
                                {!this.state.signatureDrawn && (
                                  <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", pointerEvents: "none", color: "#adb5bd" }}>
                                    <em className="icon ni ni-edit" style={{ fontSize: "24px", display: "block", marginBottom: "4px" }}></em>
                                    <span style={{ fontSize: "12px" }}>Draw your signature here</span>
                                  </div>
                                )}
                                <div style={{ position: "absolute", bottom: "20px", left: "10%", right: "10%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                              </div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderTop: "1px solid #e5e9f2" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                  {this.signatureColors.slice(0, 3).map((c, idx) => (
                                    <div key={idx} onClick={() => { this.setState({ signatureColor: c.value }); if (this.signaturePad) this.signaturePad.clear(); if (this.signaturePadModal) this.signaturePadModal.clear(); this.setState({ signatureDrawn: false }); }} title={c.name} style={{ width: (c.size || 20) + "px", height: (c.size || 20) + "px", borderRadius: "50%", backgroundColor: c.value, cursor: "pointer", border: this.state.signatureColor === c.value ? "2px solid #364a63" : "2px solid transparent", outline: this.state.signatureColor === c.value ? "2px solid #364a63" : "none", outlineOffset: "2px", transition: "all 0.15s ease" }} />
                                  ))}
                                  <div style={{ width: "1px", height: "24px", backgroundColor: "#dbdfea", margin: "0 4px" }} />
                                  {this.signatureColors.slice(3).map((c, idx) => (
                                    <div key={idx + 3} onClick={() => { this.setState({ signatureColor: c.value }); if (this.signaturePad) this.signaturePad.clear(); if (this.signaturePadModal) this.signaturePadModal.clear(); this.setState({ signatureDrawn: false }); }} title={c.name} style={{ width: (c.size || 20) + "px", height: (c.size || 20) + "px", borderRadius: "50%", backgroundColor: c.value, cursor: "pointer", border: this.state.signatureColor === c.value ? "2px solid #364a63" : "2px solid transparent", outline: this.state.signatureColor === c.value ? "2px solid #364a63" : "none", outlineOffset: "2px", transition: "all 0.15s ease" }} />
                                  ))}
                                </div>
                                <button type="button" style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }} onClick={() => { if (this.signaturePad) this.signaturePad.clear(); if (this.signaturePadModal) this.signaturePadModal.clear(); this.setState({ signatureDrawn: false }); }}>
                                  <em className="icon ni ni-undo" style={{ fontSize: "14px" }}></em> Clear
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Upload Pane */}
                      <div className={this.state.signature_type === "upload" ? "tab-pane active" : "tab-pane"} id="tabItemUpload">
                        <div
                          style={{ border: "2px dashed #dbdfea", borderRadius: "8px", padding: "30px 20px", textAlign: "center", backgroundColor: "#f8f9fc", cursor: "pointer", transition: "all 0.2s ease", position: "relative" }}
                          onClick={() => { document.getElementById("signatureUploadInput").click(); }}
                          onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.backgroundColor = THEME_COLOR + "08"; }}
                          onDragLeave={(e) => { e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; }}
                          onDrop={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; if (e.dataTransfer.files && e.dataTransfer.files[0]) { this.handleSignatureUpload({ target: { files: e.dataTransfer.files } }); } }}
                        >
                          <input type="file" id="signatureUploadInput" accept="image/png,image/jpeg,image/jpg" style={{ display: "none" }} onChange={this.handleSignatureUpload} />
                          {this.state.uploadedSignature ? (
                            <div>
                              <img src={this.state.uploadedSignature} alt="Uploaded Signature" style={{ maxWidth: "100%", maxHeight: "120px", marginBottom: "12px", border: "1px solid #e5e9f2", borderRadius: "4px", padding: "8px", backgroundColor: "#fff" }} />
                              <div>
                                <button className="btn btn-sm btn-outline-danger" onClick={(e) => { e.stopPropagation(); this.setState({ uploadedSignature: "" }); }} style={{ marginTop: "8px" }}>
                                  <em className="icon ni ni-trash"></em> Remove
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <em className="icon ni ni-upload-cloud" style={{ fontSize: "36px", color: "#8094ae", display: "block", marginBottom: "10px" }}></em>
                              <p style={{ fontSize: "13px", fontWeight: "600", color: "#364a63", marginBottom: "4px" }}>Click to upload or drag &amp; drop</p>
                              <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>PNG or JPG (max 2MB)</p>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Type Name Pane */}
                      <div className={this.state.signature_type === "type" ? "tab-pane active" : "tab-pane"} id="tabItemType">
                        <div className="form-group mb-3">
                          <MutextField required id="signatureText" name="signatureText" type="text" label="Type your full name" inputProps={{ maxLength: 30 }} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={this.state.signatureText} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" />
                        </div>
                        <div id="typed-text-container" style={{ border: "2px dashed #dbdfea", borderRadius: "8px", padding: "20px", textAlign: "center", backgroundColor: "#fafafa", minHeight: "80px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                          <em className="icon ni ni-edit" style={{ fontSize: "20px", color: "#8094ae" }}></em>
                          <span style={{ fontFamily: "'Dancing Script', cursive", fontSize: "32px", color: "#364a63" }}>{this.state.signatureText || "Your Name"}</span>
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e5e9f2", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <button className="btn btn-outline-light" onClick={() => this.goToStep(1)} style={{ height: "38px", padding: "0 16px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }}>
                        <em className="icon ni ni-arrow-left" style={{ marginRight: "4px" }}></em>Back
                      </button>
                      {this.state.loadingButton ? (
                        <button className="btn" type="button" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px" }} disabled>
                          <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span><span> Wait... </span>
                        </button>
                      ) : (
                        <button className="btn btn-lg btn-success" style={{ height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }} onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn">
                          <em className="icon ni ni-check-circle" style={{ marginRight: "4px" }}></em>Sign &amp; Complete
                        </button>
                      )}
                    </div>
                  </div>
                </>
              ) : null}

              {agreement_type === "accept" ? (
                <div id="signature_div" style={{ width: "100%", float: "none" }}>
                  <div style={{ border: this.state.is_checked === "yes" ? "1px solid #1ee0ac" : "1px solid #e5e9f2", borderRadius: "6px", padding: "14px 14px 14px 16px", marginBottom: "16px", backgroundColor: this.state.is_checked === "yes" ? "#edfff8" : "#fff", transition: "all 0.2s ease", display: "flex", alignItems: "flex-start", gap: "10px", cursor: "pointer" }} onClick={() => this.setState({ is_checked: this.state.is_checked === "yes" ? "" : "yes" })}>
                    <div style={{ width: "20px", height: "20px", borderRadius: "4px", border: this.state.is_checked === "yes" ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5", backgroundColor: this.state.is_checked === "yes" ? THEME_COLOR : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px", transition: "all 0.15s ease" }}>
                      {this.state.is_checked === "yes" && (<em className="icon ni ni-check" style={{ color: "#fff", fontSize: "13px", lineHeight: 1 }}></em>)}
                    </div>
                    <div style={{ fontSize: "13px", lineHeight: "1.6", color: "#364a63" }}>
                      I accept the <strong>{this.state.agreement_title}</strong>
                    </div>
                  </div>
                  <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e5e9f2" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        {this.state.loadingButton ? (
                          <button className="btn" type="button" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px" }} disabled>
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span><span> Wait... </span>
                          </button>
                        ) : (
                          <button className="btn btn-lg btn-success" style={{ height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }} onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn">
                            <em className="icon ni ni-check-circle" style={{ marginRight: "4px" }}></em>Accept &amp; Continue
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };
  render() {
    return (
      <div className="nk-content">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    {this.state.agreementData.length > 0 ? (
                      <h3 className="nk-block-title page-title">Agreements</h3>
                    ) : null}
                  </div>
                </div>
              </div>
              {this.state.errorMessage !== "" && this.state.agreementData.length === 0 ? (
                <div className="nk-wrap justify-center">
                  <div className="nk-content ">
                    <div className="nk-block nk-block-middle wide-md mx-auto">
                      <div className="nk-block-content nk-error-ld text-center">
                        <img className="nk-error-gfx" src={PROMO_A} alt="" />
                        <div className="wide-xs mx-auto">
                          <h3 className="nk-error-title">
                            {this.state.errorMessage}
                          </h3>
                          <p className="nk-error-text">
                            We are very sorry for inconvenience. It looks like
                            you are trying to access a page that either has been
                            deleted or never existed.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <>
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                  <center>
                    <a
                      onClick={this.close_window}
                      className="btn btn-primary mt-2"
                      style={{ color: "#fff", cursor: "pointer" }}
                    >
                      Close Window
                    </a>
                  </center>
                </>
              ) : null}
              {this.state.tableLoaderAgreement === true ? (
                tableLoaderAgreement()
              ) : (
                <div className="nk-block">
                  <div className="row g-gs">
                    <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12">
                      <div className="nk-block nk-block-lg">
                        {this.state.agreementData.length > 0 ? (
                          <>
                            {/* AGREEMENT TABS */}
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "0", marginBottom: "0", borderBottom: "1px solid #dbdfea" }}>
                              {this.state.agreementData.map((agreements, i) => {
                                const isActive = this.class_manage_link(i) === "nav-link active";
                                return (
                                  <div
                                    key={`tab-${i}`}
                                    onClick={() => {
                                      this.show_agreement_content(agreements[0], agreements[1], agreements[8], agreements[2]);
                                    }}
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      padding: "12px 16px",
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      fontFamily: "Nunito, sans-serif",
                                      color: isActive ? "#6576ff" : "#526484",
                                      borderBottom: isActive ? "3px solid #6576ff" : "3px solid transparent",
                                      marginBottom: "-1px",
                                      transition: "all 0.2s ease",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <em className="icon ni ni-file-text" style={{ fontSize: "1.4em" }}></em>
                                    <span>{agreements[2]}</span>
                                    {this.class_required(agreements[3])}
                                  </div>
                                );
                              })}
                            </div>

                            {/* TWO COLUMN LAYOUT */}
                            <div className="row g-gs" style={{ display: "flex", alignItems: "stretch" }}>
                              {/* LEFT: Document Panel */}
                              <div className="col-lg-8" style={{ display: "flex", flexDirection: "column" }}>
                                <div className="card card-bordered" style={{ backgroundColor: this.props.backgroundColor, border: "none", flex: 1, display: "flex", flexDirection: "column" }}>
                                  <div className="card-inner card-inner-xl" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                    {/* Download Button */}
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "10px" }}>
                                      <button className="btn btn-sm btn-dim btn-outline-light" onClick={() => window.$("#modalDownload").modal("show")} title="Download Agreement">
                                        <em className="icon ni ni-download" style={{ marginRight: "4px" }}></em>Download
                                      </button>
                                    </div>

                                    {/* STEPPER BAR */}
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "0", marginBottom: "16px", padding: "10px 16px", backgroundColor: "#f5f6fa", borderRadius: "6px", flexWrap: "wrap" }}>
                                      <div onClick={() => this.goToStep(1)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", padding: "6px 18px", borderRadius: "4px", backgroundColor: "transparent", color: this.state.currentStep === 1 ? THEME_COLOR : this.state.scrollProgress >= 100 && this.state.consentChecked ? "#1ee0ac" : "#526484", fontWeight: "600", fontSize: "13px", transition: "all 0.2s ease" }}>
                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "24px", height: "24px", borderRadius: "50%", backgroundColor: this.state.currentStep === 1 ? THEME_COLOR : this.state.scrollProgress >= 100 && this.state.consentChecked ? "#1ee0ac" : "#c4cdd5", color: "#fff", fontSize: "12px", fontWeight: "700" }}>{this.state.scrollProgress >= 100 && this.state.consentChecked && this.state.currentStep !== 1 ? "\u2713" : "1"}</span>
                                        Review &amp; Verify
                                      </div>
                                      <div style={{ width: "50px", height: "2px", backgroundColor: this.state.currentStep >= 2 ? THEME_COLOR : "#c4cdd5", transition: "all 0.2s ease" }} />
                                      <div onClick={() => this.goToStep(2)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: this.state.scrollProgress >= 100 && this.state.consentChecked ? "pointer" : "not-allowed", padding: "6px 18px", borderRadius: "4px", backgroundColor: "transparent", color: this.state.currentStep === 2 ? THEME_COLOR : "#8094ae", fontWeight: "600", fontSize: "13px", opacity: this.state.scrollProgress >= 100 && this.state.consentChecked ? 1 : 0.5, transition: "all 0.2s ease" }}>
                                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "24px", height: "24px", borderRadius: "50%", backgroundColor: this.state.currentStep === 2 ? THEME_COLOR : "#c4cdd5", color: "#fff", fontSize: "12px", fontWeight: "700" }}>2</span>
                                        {this.state.agreement_type === "accept" ? "Accept & Submit" : "Sign & Submit"}
                                      </div>
                                    </div>

                                    {/* SCROLLABLE DOCUMENT CONTENT */}
                                    <div
                                      className="tab-content tab-agreement_content"
                                      style={{ maxHeight: "calc(100vh - 330px)", overflowY: "auto", marginTop: "0", paddingRight: "8px" }}
                                      onScroll={this.handleDocumentScroll}
                                      ref={(el) => { this.scrollContainerRef = el; }}
                                    >
                                      {this.state.agreementData.map((agreementscontent, i) => (
                                        <div className={this.class_manage_content(i)} id={this.set_tabs_content(agreementscontent[6])} key={`agrcont${i}`}>
                                          <div
                                            id={`agreement_content_${agreementscontent[0]}`}
                                            dangerouslySetInnerHTML={{
                                              __html: REPLACECONTENTCLIENT(
                                                agreementscontent[1],
                                                this.state.replacable_content,
                                                ""
                                              ).replace(
                                                /\[\[IMG_VENDOR_SIGN\]\]/g,
                                                this.state.vendor_signature
                                              ),
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>

                                    {/* READ PROGRESS BAR */}
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 0 0", borderTop: "1px solid #e5e9f2", marginTop: "10px" }}>
                                      <em className="icon ni ni-file-text" style={{ color: "#8094ae", fontSize: "16px" }}></em>
                                      <div style={{ flex: 1 }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px", fontSize: "12px", color: "#526484" }}>
                                          <span>Read progress</span>
                                          <span style={{ fontWeight: "600" }}>{this.state.scrollProgress}%</span>
                                        </div>
                                        <div style={{ height: "6px", backgroundColor: "#e5e9f2", borderRadius: "3px", overflow: "hidden" }}>
                                          <div style={{ height: "100%", width: this.state.scrollProgress + "%", backgroundColor: this.state.scrollProgress >= 100 ? "#1ee0ac" : THEME_COLOR, borderRadius: "3px", transition: "width 0.15s ease" }} />
                                        </div>
                                      </div>
                                      {this.state.scrollProgress >= 100 && (
                                        <em className="icon ni ni-check-circle" style={{ color: "#1ee0ac", fontSize: "18px" }}></em>
                                      )}
                                      <button className="btn btn-sm btn-dim btn-outline-light" onClick={() => window.$("#modalDownload").modal("show")} title="Export Agreement">
                                        <em className="icon ni ni-share" style={{ marginRight: "4px" }}></em>Export
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* RIGHT: Side Panel */}
                              <div className="col-lg-4">
                                {this.renderStepPanel()}
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* SIGNATURE ZOOM MODAL */}
              {this.state.signatureModalOpen && (
                <div
                  style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
                  onClick={(e) => { if (e.target === e.currentTarget) this.setState({ signatureModalOpen: false }); }}
                >
                  <div style={{ backgroundColor: "#fff", borderRadius: "12px", width: "100%", maxWidth: "750px", boxShadow: "0 8px 30px rgba(0,0,0,0.25)", overflow: "hidden" }}>
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: "1px solid #e5e9f2" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#f0f3f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <em className="icon ni ni-edit" style={{ fontSize: "18px", color: "#526484" }}></em>
                        </div>
                        <div>
                          <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#364a63" }}>Draw your signature</h5>
                          <span style={{ fontSize: "13px", color: "#8094ae" }}>Use your finger, stylus, or mouse</span>
                        </div>
                      </div>
                      <button type="button" onClick={() => this.setState({ signatureModalOpen: false })} style={{ width: "32px", height: "32px", borderRadius: "50%", border: "1px solid #dbdfea", backgroundColor: "#f5f6fa", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#526484", padding: 0 }}>
                        <em className="icon ni ni-cross" style={{ fontSize: "14px" }}></em>
                      </button>
                    </div>
                    {/* Canvas Area */}
                    <div style={{ padding: "20px 24px" }}>
                      <div style={{ border: "1px solid #e5e9f2", borderRadius: "8px", height: "300px", position: "relative", backgroundColor: "#fafbfc" }}>
                        <SignatureCanvas clearOnResize={true} penColor={this.state.signatureColor} canvasProps={{ style: { width: "100%", height: "100%" } }} velocityFilterWeight={0.7} throttle={50} ref={(ref) => { this.signaturePadModal = ref; }} onBegin={() => this.setState({ modalCanvasEmpty: false })} />
                        {this.state.modalCanvasEmpty && (
                          <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                            <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#e4e7eb", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
                              <em className="icon ni ni-edit" style={{ fontSize: "22px", color: "#8094ae" }}></em>
                            </div>
                            <div style={{ fontSize: "15px", fontWeight: 500, color: "#526484" }}>Draw your signature here</div>
                            <div style={{ fontSize: "13px", color: "#8094ae", marginTop: "4px" }}>Use finger on mobile &bull; Mouse on desktop</div>
                          </div>
                        )}
                        <div style={{ position: "absolute", bottom: "50px", left: "8%", right: "8%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                      </div>
                      {/* Color Picker */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          {this.signatureColors.slice(0, 3).map((c, idx) => (
                            <button key={c.value + idx} type="button" title={c.name} onClick={() => this.setState({ signatureColor: c.value })} style={{ width: (c.size || 20) + "px", height: (c.size || 20) + "px", borderRadius: "50%", backgroundColor: c.value, border: this.state.signatureColor === c.value ? "2px solid #364a63" : "2px solid transparent", outline: this.state.signatureColor === c.value ? "2px solid #364a63" : "none", outlineOffset: "2px", cursor: "pointer", padding: 0, transition: "all 0.15s ease" }} />
                          ))}
                          <div style={{ width: "1px", height: "24px", backgroundColor: "#dbdfea", margin: "0 4px" }} />
                          {this.signatureColors.slice(3).map((c, idx) => (
                            <button key={c.value + (idx + 3)} type="button" title={c.name} onClick={() => this.setState({ signatureColor: c.value })} style={{ width: (c.size || 20) + "px", height: (c.size || 20) + "px", borderRadius: "50%", backgroundColor: c.value, border: this.state.signatureColor === c.value ? "2px solid #364a63" : "2px solid transparent", outline: this.state.signatureColor === c.value ? "2px solid #364a63" : "none", outlineOffset: "2px", cursor: "pointer", padding: 0, transition: "all 0.15s ease" }} />
                          ))}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <button type="button" style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }} onClick={() => { if (this.signaturePadModal) this.signaturePadModal.clear(); this.setState({ modalCanvasEmpty: !this.signaturePadModal || this.signaturePadModal.isEmpty() }); }}>
                            <em className="icon ni ni-undo" style={{ fontSize: "14px" }}></em> Undo
                          </button>
                          <button type="button" style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }} onClick={() => { if (this.signaturePadModal) this.signaturePadModal.clear(); if (this.signaturePad) this.signaturePad.clear(); this.setState({ signatureDrawn: false, modalCanvasEmpty: true }); }}>
                            Clear all
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Footer */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 24px", borderTop: "1px solid #e5e9f2", backgroundColor: "#fafbfc" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#8094ae", fontSize: "12px" }}>
                        <em className="icon ni ni-lock-alt" style={{ fontSize: "14px" }}></em>
                        <span>Legally binding &bull; 256-bit encrypted</span>
                      </div>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button className="btn btn-outline-light" onClick={() => this.setState({ signatureModalOpen: false })} style={{ borderRadius: "6px", padding: "8px 20px" }}>Cancel</button>
                        <button className="btn" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, borderRadius: "6px", padding: "8px 20px" }} onClick={() => {
                          if (this.signaturePadModal && !this.signaturePadModal.isEmpty()) {
                            const dataUrl = this.signaturePadModal.getTrimmedCanvas().toDataURL("image/png");
                            this.setState({ signatureModalOpen: false, signature_type: "draw", signatureDrawn: true, signatureDataUrl: dataUrl }, () => {
                              setTimeout(() => {
                                if (this.signaturePad && dataUrl) {
                                  this.signaturePad.clear();
                                  const canvas = this.signaturePad.getCanvas();
                                  const ctx = canvas.getContext("2d");
                                  const img = new Image();
                                  img.onload = () => {
                                    const ratio = Math.min(canvas.width / img.width, canvas.height / img.height) * 0.85;
                                    const x = (canvas.width - img.width * ratio) / 2;
                                    const y = (canvas.height - img.height * ratio) / 2;
                                    ctx.drawImage(img, x, y, img.width * ratio, img.height * ratio);
                                  };
                                  img.src = dataUrl;
                                }
                              }, 150);
                            });
                          }
                        }}>
                          <em className="icon ni ni-check" style={{ marginRight: "4px" }}></em>Use this signature
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* SUCCESS MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a style={{ cursor: "pointer" }} className="close" onClick={() => { this.modalHide(); }}>
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                        <h4 className="nk-modal-title">{this.state.successMessage}</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">You've successfully signed <strong>Agreement</strong></div>
                        </div>
                        <div className="nk-modal-action">
                          <a style={{ cursor: "pointer" }} className="btn btn-lg btn-mw btn-primary" onClick={() => { this.modalHide(); }}>OK</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SUCCESS MODAL End */}
              {/* ERROR MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlertError">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                        <h4 className="nk-modal-title">Unable to Upload!</h4>
                        <div className="nk-modal-text">
                          <p className="lead">{this.state.errorMessage}</p>
                        </div>
                        <div className="nk-modal-action mt-5">
                          <a href="#" className="btn btn-lg btn-mw btn-light" data-dismiss="modal">Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ERROR MODAL END */}
              {/* DOWNLOAD MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalDownload" data-backdrop={this.state.downloading ? "static" : true} data-keyboard={!this.state.downloading}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content" style={{ borderRadius: "16px", border: "none", overflow: "hidden", position: "relative" }}>
                    {this.state.downloading && (
                      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255,255,255,0.92)", zIndex: 10, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "16px" }}>
                        <div style={{ width: "48px", height: "48px", border: "4px solid #e5e9f2", borderTopColor: THEME_COLOR, borderRadius: "50%", animation: "spin 0.8s linear infinite", marginBottom: "16px" }} />
                        <h6 style={{ fontWeight: 600, fontSize: "15px", color: "#364a63", marginBottom: "4px" }}>Preparing your {this.state.downloadingFormat} file...</h6>
                        <p style={{ color: "#8094ae", fontSize: "13px", margin: 0 }}>This may take a moment</p>
                      </div>
                    )}
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    <div className="modal-body" style={{ padding: "32px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" }}>
                        <div style={{ width: "48px", height: "48px", borderRadius: "12px", backgroundColor: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <em className="icon ni ni-download" style={{ fontSize: "22px", color: "#526484" }}></em>
                        </div>
                        <div>
                          <h5 style={{ fontWeight: 700, fontSize: "20px", margin: "0 0 4px 0", color: "#364a63" }}>Download Agreement</h5>
                          <p style={{ color: "#8094ae", fontSize: "14px", margin: 0 }}>{this.state.agreement_title}</p>
                        </div>
                      </div>
                      <p style={{ color: "#526484", fontSize: "14px", lineHeight: "1.6", marginBottom: "24px" }}>Choose a format to download this agreement.</p>
                      {/* PDF Option */}
                      <div onClick={() => { if (!this.state.downloading) this.downloadPdf(); }} style={{ display: "flex", alignItems: "center", padding: "16px", border: "2px solid #ff6b35", borderRadius: "12px", cursor: this.state.downloading ? "not-allowed" : "pointer", marginBottom: "12px", opacity: this.state.downloading ? 0.5 : 1 }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "8px", backgroundColor: "#fff5f0", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "14px", flexShrink: 0 }}>
                          <em className="icon ni ni-file-pdf" style={{ fontSize: "20px", color: "#ff6b35" }}></em>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: "15px", color: "#364a63" }}>PDF Document</div>
                          <div style={{ fontSize: "13px", color: "#8094ae" }}>Best for printing</div>
                        </div>
                        <em className="icon ni ni-download" style={{ fontSize: "18px", color: "#8094ae" }}></em>
                      </div>
                      {/* TXT Option */}
                      <div onClick={() => { if (!this.state.downloading) this.downloadTxt(); }} style={{ display: "flex", alignItems: "center", padding: "16px", border: "1px solid #e5e9f2", borderRadius: "12px", cursor: this.state.downloading ? "not-allowed" : "pointer", marginBottom: "12px", opacity: this.state.downloading ? 0.5 : 1 }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "8px", backgroundColor: "#fff8e1", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "14px", flexShrink: 0 }}>
                          <em className="icon ni ni-file-text" style={{ fontSize: "20px", color: "#f9a825" }}></em>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: "15px", color: "#364a63" }}>Plain Text (.txt)</div>
                          <div style={{ fontSize: "13px", color: "#8094ae" }}>Lightweight copy for quick reference</div>
                        </div>
                        <em className="icon ni ni-download" style={{ fontSize: "18px", color: "#8094ae" }}></em>
                      </div>
                      <div style={{ textAlign: "right", marginTop: "16px" }}>
                        <button className="btn btn-outline-light" data-dismiss="modal" style={{ height: "38px", padding: "0 20px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }}>
                          <em className="icon ni ni-cross" style={{ marginRight: "4px" }}></em>Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* DOWNLOAD MODAL END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}